import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import user from './user';
import organization from './organization';
import analytics from './analytics';
import advertisement from './advertisement';
import search from './search';
import recommendation from './recommendation'

export default combineReducers({
	router: routerReducer,
	user,
	organization,
	analytics,
	advertisement,
	search,
	recommendation
});
